import React from 'react';
import { PAYMENT_AR } from '../../utils/money';

const STYLES = {
  paid_full: { color: 'var(--success)', bg: 'var(--success-light)' },
  paid_partial: { color: 'var(--warning)', bg: 'var(--warning-light)' },
  unpaid: { color: 'var(--text-muted)', bg: 'var(--surface-alt)' },
  unknown: { color: 'var(--text-muted)', bg: 'var(--surface-alt)' },
};

export default function PaymentBadge({ status }) {
  const s = STYLES[status] || STYLES.unknown;
  return (
    <span className="badge" style={{ color: s.color, background: s.bg, border: `1px solid ${s.color}40` }}>
      {PAYMENT_AR[status] || PAYMENT_AR.unknown}
    </span>
  );
}
